import { render, staticRenderFns } from "./NewRetailPart2.vue?vue&type=template&id=7d120b79&scoped=true&"
import script from "./NewRetailPart2.vue?vue&type=script&lang=js&"
export * from "./NewRetailPart2.vue?vue&type=script&lang=js&"
import style0 from "./NewRetailPart2.vue?vue&type=style&index=0&id=7d120b79&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d120b79",
  null
  
)

export default component.exports